export default __webpack_public_path__ + "static/media/House.70ab2a44.jpg";